import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AgreementSchema = withDefaults({
  type: 'agreement',
  fields: [
    {
      kind: 'attribute',
      name: 'classification',
    },
    {
      kind: 'attribute',
      name: 'province',
    },
    {
      kind: 'attribute',
      name: 'agreedUponFilename',
    },
    {
      kind: 'attribute',
      name: 'agreedUponText',
    },
    {
      kind: 'attribute',
      name: 'expiryDate',
    },
    {
      kind: 'attribute',
      name: 'isExpired',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: 'agreements',
      },
    },
    {
      kind: 'belongsTo',
      name: 'condition',
      type: 'condition',
      options: {
        async: false,
        inverse: 'agreements',
      },
    },
  ],
});

export default AgreementSchema;
